import { CommonService } from './../../Services/common.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  logout: boolean = false;

  constructor(public commonP: CommonService, private _router: Router) { }

  async ngOnInit() {
    this.logout = false;
    let a = await this.commonP.Get('token');
    if (a) {
      this.logout = true;
    }
  }

  getLogin() {

  }
  logoutbtn() {
    this.commonP.delete('User');
    this.commonP.delete('token');
    this.commonP.delete('productId');
    this.commonP.delete('idcardexpire');
    this._router.navigateByUrl('/MobileVerification');
  }

}
